import { createAnimations } from '@tamagui/animations-css'

export const animations = createAnimations({
  lazy: 'ease-in 500ms',
  quick: 'ease-in 100ms',
})
